var _path, _rect, _path2, _rect2, _rect3, _path3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManufacturing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "Manufacturing",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.45 26.11l-12-6a1 1 0 0 0-.9 0l-12 6A1 1 0 0 0 36 27V39a1 1 0 0 0 .55.89l12 6a1 1 0 0 0 .9 0l12-6A1 1 0 0 0 62 39V27A1 1 0 0 0 61.45 26.11zM49 22.12L58.76 27 55 28.88 45.24 24zM48 43.38l-10-5V28.62l10 5zm1-11.5L39.24 27 43 25.12 52.76 30zm11 6.5l-10 5V33.62l10-5zM3 42H13.08A8 8 0 1 0 22 30.26V21a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1V41A1 1 0 0 0 3 42zm17-1a1 1 0 0 1-1-1H17a3 3 0 0 0 2 2.82v1.09a6 6 0 0 1 0-11.82v1.09A3 3 0 0 0 20 39a1 1 0 0 1 0 2zm1-5h2a3 3 0 0 0-2-2.82V32.09a6 6 0 0 1 0 11.82V42.82A3 3 0 0 0 20 37a1 1 0 1 1 1-1zM4 22H20v8a8 8 0 0 0-8 8 8.24 8.24 0 0 0 .26 2H4zM12.41 4.32A1 1 0 0 0 13 3.4a1 1 0 0 0-.61-.91A6.16 6.16 0 0 0 10 2 6 6 0 0 0 4 8H3a1 1 0 0 0-.78 1.63l4 5a1 1 0 0 0 1.56 0l4-5A1 1 0 0 0 11 8H10A4 4 0 0 1 12.41 4.32zM8.14 9.24a1 1 0 0 0 .79.74L7 12.4 5.08 10A1 1 0 0 0 6 8.79a1.59 1.59 0 0 1 0-.38C6 8.27 6 8.14 6 8A4 4 0 0 1 9.5 4 6 6 0 0 0 8 8 5.22 5.22 0 0 0 8.14 9.24zM9.63 52.22A1 1 0 0 0 8 53v1a4 4 0 0 1-3.68-2.41A1 1 0 0 0 3.41 51h0a1 1 0 0 0-.91.61A6.16 6.16 0 0 0 2 54a6 6 0 0 0 6 6v1a1 1 0 0 0 .57.9A.94.94 0 0 0 9 62a1 1 0 0 0 .63-.22l5-4a1 1 0 0 0 0-1.56zm.37 6.7a1 1 0 0 0-.37-.7A1 1 0 0 0 9 58l-.21 0a1.59 1.59 0 0 1-.38 0L8 58a4 4 0 0 1-4-3.5A6 6 0 0 0 8 56a5.22 5.22 0 0 0 1.24-.14 1 1 0 0 0 .74-.79L12.4 57zM57.78 49.38a1 1 0 0 0-1.56 0l-4 5a1 1 0 0 0-.12 1A1 1 0 0 0 53 56h1a4 4 0 0 1-2.41 3.68 1 1 0 0 0-.59.92 1 1 0 0 0 .61.91A6.16 6.16 0 0 0 54 62a6 6 0 0 0 6-6h1a1 1 0 0 0 .9-.57 1 1 0 0 0-.12-1zm.44 5a1 1 0 0 0-.2.84 1.59 1.59 0 0 1 0 .38c0 .14 0 .27 0 .41a4 4 0 0 1-3.5 4A6 6 0 0 0 56 56a5.22 5.22 0 0 0-.14-1.24 1 1 0 0 0-.79-.74L57 51.6 58.92 54A1 1 0 0 0 58.22 54.37zM56 4V3a1 1 0 0 0-.57-.9 1 1 0 0 0-1 .12l-5 4a1 1 0 0 0 0 1.56l5 4a1 1 0 0 0 1 .12A1 1 0 0 0 56 11V10a4 4 0 0 1 3.68 2.41 1 1 0 0 0 .91.59h0a1 1 0 0 0 .91-.61A6.16 6.16 0 0 0 62 10 6 6 0 0 0 56 4zm0 4a5.22 5.22 0 0 0-1.24.14 1 1 0 0 0-.74.79L51.6 7 54 5.08a1 1 0 0 0 1.21.9 1.59 1.59 0 0 1 .38 0L56 6a4 4 0 0 1 4 3.5A6 6 0 0 0 56 8z",
    fill: "#21929b",
    className: "color000000 svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    x: 29,
    y: 53,
    fill: "#21929b",
    className: "color000000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.71,51.29A1,1,0,0,0,46,51H43V50a1,1,0,0,0-1-1H26a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1h2.18a3,3,0,0,0,5.64,0h6.23v-.51a3,3,0,0,0,5.77.51H48a1,1,0,0,0,1-1V54a1,1,0,0,0-.29-.71ZM31,60a1,1,0,1,1,1-1A1,1,0,0,1,31,60Zm10-3.22a3,3,0,0,0-1,1.73V58H33.82a3,3,0,0,0-5.64,0H27V51H41ZM43,60a1,1,0,1,1,1-1A1,1,0,0,1,43,60Zm4-2H45.82A3,3,0,0,0,43,56V53h2.59L47,54.41Z",
    fill: "#21929b",
    className: "color000000 svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    x: 17,
    y: 57,
    fill: "#21929b",
    className: "color000000 svgShape"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 19,
    y: 53,
    fill: "#21929b",
    className: "color000000 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 8.82V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V7a1 1 0 0 0-.4-.8A1 1 0 0 0 35.71 6l-6 1.82A1 1 0 0 0 29 8.82zm2 .74l4-1.21V16H31zM44.71 3l-6 1.82a1 1 0 0 0-.71 1V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-.4-.8A1 1 0 0 0 44.71 3zM44 16H40V6.56l4-1.21zM25 7H21a1 1 0 0 0-1 1v3H19a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V12a1 1 0 0 0-1-1H26V8A1 1 0 0 0 25 7zm1 9H20V13h1a1 1 0 0 0 1-1V9h2v3a1 1 0 0 0 1 1h1zM28 2H23a1 1 0 0 0-1 1V5h2V4h4z",
    fill: "#21929b",
    className: "color000000 svgShape"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 30,
    y: 2,
    fill: "#21929b",
    className: "color000000 svgShape"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 34,
    y: 2,
    fill: "#21929b",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturing);
export default __webpack_public_path__ + "static/media/manufacturing.f77bab4ea292fd267aa1de14cbd061ca.svg";
export { ForwardRef as ReactComponent };